import React from 'react';

import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';
import { Branch } from '../../../../../../generated/model/models';
import DetailsDataTableWithHistory from '../../shared/DetailsDataTableWithHistory';

export interface Props {
  data?: Branch;
}

const columns: MainColumns[] = [
  { field: 'number', minWidth: 200, flex: 1 },
  { field: 'name', minWidth: 200, flex: 1, autoHeight: true, cellClass: 'multipleLineCell' },
  { field: 'country', minWidth: 200, flex: 1 },
  {
    field: 'address.address',
    minWidth: 300,
    cellRenderer: CellRenderer.BranchAddress,
    flex: 1,
    cellClass: 'multipleLineCell',
    autoHeight: true,
  },
  { field: 'emailAddress', minWidth: 200, flex: 1 },
  { field: 'phone', minWidth: 200, flex: 1 },
  { field: 'officialValidFrom', minWidth: 150, flex: 1 },
  { field: 'officialValidTo', minWidth: 150, flex: 1 },
];

const OwnershipBranchesList: React.FC<Props> = ({ data }) => {
  return (
    <DetailsDataTableWithHistory
      title={'branches'}
      translationsScope={'companies:companyBranches'}
      data={data}
      columns={columns}
      defaultHistoryToggleValue={true}
    />
  );
};

export default OwnershipBranchesList;
